import { css } from "@emotion/react";

// import { COLORS } from "../../stylesheets/emotion/vars";
// import image from "../images/mississippi/mississippi-pattern.png";

export const deSteegStyleVertical = css`
    body {
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .bannerBack {
        width: 17.5%;
        margin-top: 0.55vw;
        position: absolute;
        margin-left: 53.6%;
    }

    .bannerFront {
        width: 19%;
        margin-left: 27.3%;
        margin-top: 0.68vw;
        position: absolute;
    }

    .bannerLogo {
        width: 10vw;
        position: relative;
        margin-top: 0.1vw;
        margin-left: 112.2%;
        z-index: 1000;
        filter: drop-shadow(0px 5px 5px #000);
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.15;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.3;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
    }

    @keyframes opacity {
        0% {
            opacity: 0.05;
        }
        50% {
            opacity: 0.2;
        }
        100% {
            opacity: 0.05;
        }
    }

    .menukaart {
        width: 100vw;
        height: 100vw;
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .menulinks {
        width: 45vw;
        height: 45vw;
        margin-left: 2.5vw;
        margin-top: 2vw;
        position: relative;
    }

    .menurechts {
        width: 45vw;
        height: 45vw;
        margin-left: 3.5vw;
        margin-top: 2vw;
        position: relative;
    }

    .backgroundShadow {
        background-color: transparent;
        border-radius: 0px;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
    }

    .row {
        display: flex;
        padding-top: 0.1vw;
        background-color: transparent;
        border-bottom: 1px solid white;
    }

    .row:nth-last-child(1) {
        border-bottom-left-radius: 0vw;
        border-bottom-right-radius: 0vw;
    }

    .rowContent {
        padding: 0.25vw 0;
        display: flex;
    }

    .productkind {
        color: white;
        font-size: 0.5vw;
        margin-top: 0.1vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    .bannerAll {
        display: hidden;
        height: 5vh;
    }

    .bannerLogo {
        display: hidden;
    }

    .pagebackground {
        background-color: #000;
        background-image: url("/images/pricelist/deSteegLogoColor.png")
        background-repeat: no-repeat;
        background-size: 20% 20%;
        z-index: 10;
        width: 100vw;
    }

    .pattern {
        background-image: url("/images/pricelist/smokeBackground.gif");
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0%;
        opacity: 0.5;
        filter: blur(2px);
        z-index: 0;
    }

    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .logo {
        position: absolute;
        margin-left: 20%;
        margin-top: -5%;
        width: 20%;
        opacity: 0;
    }

    .marginTopTitle {
        margin-top: -4vw;
    }

    .title {
        margin-left: 1vw;
        font-size: 1vw;
        font-weight: 600;
        margin-top: 1vw;
        margin-bottom: 0.5vw;
        position: relative;
        width: 20.3vw;
        color: white;
        text-shadow: 2px 2px #000000;
    }

    .titleNotAtTop {
        margin-left: 1vw;
        font-size: 1vw;
        font-weight: 600;
        margin-top: 0.6vw;
        margin-bottom: 0.5vw;
        position: relative;
        width: 20vw;
        color: white;
        text-shadow: 2px 2px #000000;
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        margin: auto;
        padding: 0 0.5vw;
    }

    .nameStar {
        display: flex;
    }

    .newBadge {
    }

    .nameprice {
        font-size: 0.7vw;
        text-transform: uppercase;
        color: white;
        font-weight: 600;
    }

    .description {
        font-size: 0.6vw;
        color: white;
        margin: 0 auto;
    }

    .kind {
        font-size: 0.3vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: white;
    }

    .priceContainer {
        position: relative;
        left: 1.4vw;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .price {
        font-size: 0.7vw;
        width: 3.5vw;
        color: white;
    }

    .priceHeader {
        position: relative;
        left: 1.35vw;
        margin-left: -0.55vw;
        font-size: 0.7vw;
        margin-top: -1.5vw;
        width: 4vw;
        color: white;
    }

    .filler {
        flex-grow: 1;
    }

    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 10px;
    }
`;
